/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Insolvency_TitleInputs */

const cs_property_registry_insolvency_title = /** @type {(inputs: Property_Registry_Insolvency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insolvence (ISIR)`)
};

const en_property_registry_insolvency_title = /** @type {(inputs: Property_Registry_Insolvency_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insolvency (ISIR)`)
};

/**
* | output |
* | --- |
* | "Insolvency (ISIR)" |
*
* @param {Property_Registry_Insolvency_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_insolvency_title = /** @type {((inputs?: Property_Registry_Insolvency_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Insolvency_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_insolvency_title(inputs)
	return cs_property_registry_insolvency_title(inputs)
});